import { render, staticRenderFns } from "./DiskExtChart.vue?vue&type=template&id=3e87758e&scoped=true&"
import script from "./DiskExtChart.vue?vue&type=script&lang=js&"
export * from "./DiskExtChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e87758e",
  null
  
)

export default component.exports